import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home'
// import Profile from '../views/Profile'
// import Courses from '../views/Courses'
// import Course from '../views/Course'
// import Teachers from '../views/Teachers'
// import Teacher from '../views/Teacher'
// import Register from '../views/Register'
// import Employ from '../views/Employ'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/profile',
    name: 'profile',
    component: ()=>import(/* webpackChunkName: "profile" */ "../views/Profile")
  },
  {
    path: '/edit/profile',
    name: 'editProfile',
    component: ()=>import(/* webpackChunkName: "editProfile" */ "../views/EditProfile")
  },
  {
    path: '/courses',
    name: 'courses',
    component: ()=>import(/* webpackChunkName: "courses" */ "../views/Courses"),
    props: true,
    params:true,

  },
  {
    path: '/course/:id',
    name: 'course',
    component: ()=>import(/* webpackChunkName: "course" */ "../views/Course")
  },
  {
    path: '/register',
    name: 'register',
    component: ()=>import(/* webpackChunkName: "register" */ "../views/Register")
  },
  {
    path: '/employ',
    name: 'employ',
    component: ()=>import(/* webpackChunkName: "employ" */ "../views/Employ")
  },
  {
    path: '/online',
    name: 'online',
    component: ()=>import(/* webpackChunkName: "online" */ "../views/Online")
  },
 {
    path: '/present',
    name: 'present',
    component: ()=>import(/* webpackChunkName: "present" */ "../views/Present")
  },
 {
    path: '/book',
    name: 'book',
    component: ()=>import(/* webpackChunkName: "book" */ "../views/Book")
  },
 {
    path: '/videoo',
    name: 'video',
    component: ()=>import(/* webpackChunkName: "video" */ "../views/Video")
  },


  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
